import { InternalBet, SlotMachineInfo } from '@cgs/data-access';
import { EnvironmentConfig } from '@cgs/shared';
import { StartStateDto } from '../../models';
import { machineStateMapper } from './machine-state.mapper';
import { symbolMapper } from './symbol.mapper';

export function betsMapper(bets: number[]): InternalBet[] {
  return bets
    .sort((a, b) => a - b)
    .map((bet) => {
      const internalBet: InternalBet = new InternalBet();
      internalBet.bet = bet;
      internalBet.effectiveBet = -1.0;
      return internalBet;
    });
}

export function startStateMapper(state: StartStateDto): SlotMachineInfo {
  const startResponse: SlotMachineInfo = new SlotMachineInfo();

  startResponse.bets = betsMapper(state.bets);
  startResponse.maxLines = state.maxLines || 0;

  startResponse.lines = Array.from({ length: startResponse.maxLines }, (_, i) => i + 1);

  startResponse.machineState = state.machineState ? machineStateMapper(state.machineState) : null;
  startResponse.symbols = (state.symbols || []).map(symbolMapper);
  startResponse.betMultiplier = state.betMultiplier;
  startResponse.defaultBet = state.defaultBet;
  startResponse.cheatUser = state.isCheatUser || EnvironmentConfig.isCheatEnabled;
  startResponse.configs = state.configs || [];
  startResponse.cheatCommands = state.commands || [];
  startResponse.cheatReels = false;
  startResponse.customCheatInput = false;

  // TODO: check and remove this ???
  if (startResponse.machineState?.isBonus && startResponse.machineState.winLines) {
    startResponse.machineState.winLines.length = 0;
  }

  return startResponse;
}
